<script>
const name = 'TranslationPlaceholder';

export default {
    functional: true,
    render() {
        console.warn('TranslationPlaceholder is Deperated');
        return <div>{name}</div>;
    },
};
</script>
